export const DELETE_TRANSLATION = 'DELETE_TRANSLATION';

export const INITIALIZE_TRANSLATIONS_DATA = 'INITIALIZE_TRANSLATIONS_DATA';

export const UPDATE_TRANSLATION = 'UPDATE_TRANSLATION';

export const UPDATE_TRANSLATION_GROUP_PURPOSE = 'UPDATE_TRANSLATION_GROUP_PURPOSE';

export const UPDATE_TRANSLATIONS = 'UPDATE_TRANSLATIONS';
